var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxSwapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_39_1559)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 27.302L18.1818 12.1741C18.1818 12.0785 18.1 12.0002 18 12.0002L16.6364 12.0002C16.5364 12.0002 16.4545 12.0785 16.4545 12.1741L16.4545 25.3303L12.2955 22.1934C12.1773 22.1043 12 22.1848 12 22.3304L12 23.9064C12 24.013 12.05 24.113 12.1386 24.1804L17.0045 27.8498C17.4818 28.2085 18.1818 27.8846 18.1818 27.302ZM23.5455 27.8259L23.5455 14.6697L27.7045 17.8066C27.8227 17.8957 28 17.8153 28 17.6697L28 16.0936C28 15.9871 27.95 15.8871 27.8614 15.8197L22.9955 12.1502C22.5182 11.7915 21.8182 12.1155 21.8182 12.6959L21.8182 27.8259C21.8182 27.9216 21.9 27.9998 22 27.9998L23.3636 27.9998C23.4636 27.9998 23.5455 27.9216 23.5455 27.8259Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_1559",
    x1: 8.67025,
    y1: 8.16974,
    x2: 45.181,
    y2: 29.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSwapIcon);
export default __webpack_public_path__ + "static/media/box_Swap_icon.4619209475c3264c1955caa669c6c3cf.svg";
export { ForwardRef as ReactComponent };